import styles from './AssetLoadError.module.scss'

/**
 * AssetLoadError — compact error state for failed asset loads (floor plans, thumbs, etc.).
 *
 * Designed to fill its parent container (use inside aspect-ratio wrappers, image slots, etc.).
 * Not for full-screen loading — use the pulsing `Loading` component for that.
 *
 * `logoSrc` should come from AppContext (`useApp().logoSrc`) which resolves it once
 * for the whole app via sequential HEAD requests (project → developer → APLUS mark).
 * Do NOT call `useProjectLogo` per-instance — that would fire N×4 HEAD requests.
 *
 * @param {object}       props
 * @param {string|null}  [props.logoSrc]   - Pre-resolved logo URL (from AppContext)
 * @param {string}       [props.message]   - Error text; defaults to a generic load-error message
 * @param {string}       [props.className]
 */
export function AssetLoadError({ logoSrc, message, className }) {
  const errorMessage = message ?? 'Nie udało się załadować pliku'

  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')} aria-hidden="true">
      {logoSrc && (
        <img
          src={logoSrc}
          alt=""
          className={styles.logo}
        />
      )}
      <p className={styles.message}>{errorMessage}</p>
    </div>
  )
}
